
import { PROJECT_BRANDS } from '@/modules/brand/domain/brand';

import Contact from './components/contact/contact.vue';

export default {
  name: 'ContactPage',

  components: {
    Contact,
  },

  layout: 'static',

  head() {
    return {
      title: this.meta,
    };
  },

  computed: {
    meta() {
      return this.$getBrand() === PROJECT_BRANDS.reverse
        ? { title: this.$t('contact.meta.title') }
        : { title: this.$t('contactMuscleCharge.meta.title') };
    },
  },
};
